import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import './Toggle.scss';

var Toggle = function Toggle(_ref) {
  var _ref$round = _ref.round,
      round = _ref$round === void 0 ? true : _ref$round,
      onClick = _ref.onClick,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      label = _ref.label;

  var _useState = useState(checked),
      _useState2 = _slicedToArray(_useState, 2),
      isChecked = _useState2[0],
      setIsChecked = _useState2[1];

  var handleOnClick = function handleOnClick(e) {
    setIsChecked(!isChecked);
    onClick && onClick(e.target.checked);
  };

  useEffect(function () {
    setIsChecked(checked);
  }, [checked]);
  return /*#__PURE__*/React.createElement("div", {
    className: "pwd-toggle-component"
  }, /*#__PURE__*/React.createElement("label", {
    className: "pwd-toggle-content"
  }, /*#__PURE__*/React.createElement("span", {
    className: "pwd-label"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "pwd-switch"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    onChange: handleOnClick,
    checked: isChecked
  }), /*#__PURE__*/React.createElement("span", {
    className: "pwd-slider ".concat(round && 'pwd-round')
  }))));
};

export default Toggle;